<div
  class="bn-general-container-info"
  [formGroup]="form"
  (mousedown)="onTouch()"
  (touchstart)="onTouch()">
  <div class="bn-form__label d-flex">Startup Command</div>
  <p class="bn-form__description bn-form__description--after">
    <span after="">Configures a custom startup command that will execute once the container is launched.</span>
  </p>

  <!-- Commands section -->
  <div class="bn-container bg-card-inside border-radius-lg shadow-2 mt-2 pt-2 pb-2 px-2 px-sm-4">
    <p class="mb-2 mt-0 color-dark-7">{{ 'COMPONENTS.ADVANCED-SETTINGS-COMMANDS.PRE-TEXT' | translate }}</p>
    <!-- Commands as list -->
    <bn-web-ui-tag-select
      class="mb-2"
      data-e2e="AppAppAdvancedStartupCommandList"
      formControlName="startupCommands"
      size="md"
      [id]="'startupCommands'"
      [inputName]="'COMPONENTS.ADVANCED-SETTINGS-COMMANDS.NAME-1' | translate"
      [isMinHeight]="true"
      [placeholder]="'COMPONENTS.ADVANCED-SETTINGS-COMMANDS.PLACEHOLDER-1' | translate" />

    <!-- Command input is a preview only -->
    <!--bn-web-ui-input
      class="my-2"
      data-e2e="AppAppAdvancedStartup"
      size="md"
      formControlName="startupCommand"
      itemStyle="tertiary"
      [inputName]="'COMPONENTS.ADVANCED-SETTINGS-COMMANDS.NAME-2' | translate"
      [placeholder]="'COMPONENTS.ADVANCED-SETTINGS-COMMANDS.PLACEHOLDER-2' | translate"
      [options]="{
        leftAddons: [{ value: ('COMPONENTS.ADVANCED-SETTINGS-COMMANDS.LEFT-ADDON-TEXT-2' | translate), hasBg: true }],
        rightAddons: [{ icon: 'copy', action: 'copyToClipboard', tooltip: ('ACTION.COPY-TO-CLIPBOARD' | translate) }],
      }"
      [readonly]="true">
    </bn-web-ui-input-->
  </div>

  <hr class="mt-4 mb-3" />
  <bn-web-ui-input
    data-e2e="AppAppAdvancedArguments"
    formControlName="containerArgs"
    inputName="Container arguments"
    label="Container Arguments"
    placeholder=""
    size="md"
    [readonly]="readonly"
    [withOverride]="true">
    <span after>Configures the container arguments that will be added to the container entry point when starting the image.</span>
  </bn-web-ui-input>

  <hr class="mt-4 mb-3" />
  <bn-web-ui-input
    class="pb-4"
    data-e2e="AppAppAdvancedDir"
    formControlName="workingDir"
    inputName="Working Dir"
    label="Working Dir"
    placeholder=""
    size="md"
    [readonly]="readonly"
    [withOverride]="true">
    <span after>Configures the working directory of the container runtime.</span>
  </bn-web-ui-input>
</div>
